import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/iris-ui";
/* empty css                          */
const ProductDiscountBadge = ({
  className,
  discount,
  isWide = false,
  label
}) => /* @__PURE__ */ React.createElement("div", { className: classnames("product-discount-badge", className), "data-t": "product-discount" }, /* @__PURE__ */ React.createElement(
  Text,
  {
    variant: "caption-head",
    component: "div",
    className: "product-discount-badge__value",
    "data-t": "product-discount-value"
  },
  discount
), label && /* @__PURE__ */ React.createElement(
  Text,
  {
    variant: "caption-head",
    component: "div",
    className: classnames("product-discount-badge__label", {
      "product-discount-badge__label--wide": isWide
    }),
    "data-t": "product-discount-label"
  },
  /* @__PURE__ */ React.createElement("span", { className: "product-discount-badge__label-overflow" }, label)
));
export {
  ProductDiscountBadge
};
//# sourceMappingURL=ProductDiscountBadge.js.map
